export const notificationsData = [
  {
    id: 1,
    company: 'Global Innovations Corp',
    logo: '',
    title: 'Enterprise CRM Integration Project',
    description:
      'A new proposal request for integrating a custom CRM solution across multiple',
    status: 'Pending',
    createdAt: '2025-12-16T10:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 2,
    company: 'Tech Solutions Inc.',
    logo: '',
    title: 'Website Redesign & SEO Optimization',
    description:
      'Update on the proposal for a comprehensive website redesign and ongoing SEO services.',
    status: 'Accepted',
    createdAt: '2025-12-16T07:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 3,
    company: 'Creative Marketing Agency',
    logo: '',
    title: 'Social Media Campaign Management',
    description:
      'The social media campaign proposal has been declined due to budget reallocations.',
    status: 'Declined',
    createdAt: '2025-12-15T12:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 4,
    company: 'Healthcare Innovations',
    logo: '',
    title: 'AI-Powered Diagnostic Tool Development',
    description:
      'New request for proposal to develop an AI-powered diagnostic tool for medical',
    status: 'Pending',
    createdAt: '2025-12-14T12:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 5,
    company: 'Fintech Solutions Ltd.',
    logo: '',
    title: 'Blockchain Security Audit',
    description:
      'Proposal ignored: Request for a comprehensive security audit of existing',
    status: 'Ignored',
    createdAt: '2025-12-13T12:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 6,
    company: 'Manufacturing Co.',
    logo: '',
    title: 'Automated Production Line Upgrade',
    description:
      'A detailed proposal has been submitted for upgrading the automated production line.',
    status: 'Accepted',
    createdAt: '2025-12-12T12:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 7,
    company: 'CloudScale Systems',
    logo: '',
    title: 'Multi-Region Kubernetes Migration',
    description:
      'New proposal request to migrate workloads to a multi-region Kubernetes setup with CI/CD.',
    status: 'Pending',
    createdAt: '2025-12-16T06:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 8,
    company: 'GreenEnergy Partners',
    logo: '',
    title: 'IoT Monitoring Dashboard',
    description:
      'Update: Stakeholders requested a revised timeline for the IoT monitoring dashboard rollout.',
    status: 'Accepted',
    createdAt: '2025-12-16T04:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 9,
    company: 'RetailX Commerce',
    logo: '',
    title: 'Checkout Performance Optimization',
    description:
      'New proposal request to reduce checkout latency and improve conversion on mobile devices.',
    status: 'Pending',
    createdAt: '2025-12-16T02:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 10,
    company: 'Apex FinOps',
    logo: '',
    title: 'Cost Optimization Review',
    description:
      'Update: Proposal declined due to internal budgeting changes and shifting priorities.',
    status: 'Declined',
    createdAt: '2025-12-16T00:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 11,
    company: 'MedAxis Labs',
    logo: '',
    title: 'Patient Portal Revamp',
    description:
      'New proposal request to redesign the patient portal with accessibility and security upgrades.',
    status: 'Pending',
    createdAt: '2025-12-15T11:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 12,
    company: 'LogiChain Freight',
    logo: '',
    title: 'Route Planning Automation',
    description:
      'Update: Proposal ignored as the team decided to postpone automation work this quarter.',
    status: 'Ignored',
    createdAt: '2025-12-15T10:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 13,
    company: 'EduNext Platform',
    logo: '',
    title: 'Learning Analytics Module',
    description:
      'New proposal request to build learning analytics dashboards with cohort-based insights.',
    status: 'Pending',
    createdAt: '2025-12-14T11:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 14,
    company: 'SecureBank IT',
    logo: '',
    title: 'Zero Trust Network Rollout',
    description:
      'Update: Accepted proposal for phased implementation of Zero Trust policies and device posture.',
    status: 'Accepted',
    createdAt: '2025-12-14T10:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 15,
    company: 'Nova Media Group',
    logo: '',
    title: 'Content Pipeline Automation',
    description:
      'New proposal request to automate content ingestion, tagging, and publishing workflows.',
    status: 'Pending',
    createdAt: '2025-12-14T09:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 16,
    company: 'AutoParts Direct',
    logo: '',
    title: 'Inventory Reconciliation Tool',
    description:
      'Update: Proposal declined due to overlap with an existing internal tooling initiative.',
    status: 'Declined',
    createdAt: '2025-12-13T11:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 17,
    company: 'Skyline Realty',
    logo: '',
    title: 'Lead Management CRM Setup',
    description:
      'New proposal request to implement CRM lead tracking and automated follow-ups for agents.',
    status: 'Pending',
    createdAt: '2025-12-13T10:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 18,
    company: 'Quantum QA Services',
    logo: '',
    title: 'Automated Regression Suite',
    description:
      'Update: Accepted proposal for setting up automated regression tests and nightly pipelines.',
    status: 'Accepted',
    createdAt: '2025-12-12T11:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 19,
    company: 'CityTransit Authority',
    logo: '',
    title: 'Passenger App Modernization',
    description:
      'New proposal request to modernize the passenger app with realtime arrivals and alerts.',
    status: 'Pending',
    createdAt: '2025-12-11T12:00:00Z',
    type: 'proposal',
    isRead: false,
  },
  {
    id: 20,
    company: 'FoodChain Kitchens',
    logo: '',
    title: 'Delivery ETA Prediction',
    description:
      'Update: Proposal ignored after vendor selection was paused pending executive review.',
    status: 'Ignored',
    createdAt: '2025-12-10T12:00:00Z',
    type: 'update',
    isRead: true,
  },
  {
    id: 21,
    company: 'BioTech Frontier',
    logo: '',
    title: 'Lab Data Lake Implementation',
    description:
      'New proposal request to build a secure data lake for lab instrumentation and reporting.',
    status: 'Pending',
    createdAt: '2025-12-09T08:17:00Z',
    type: 'proposal',
    isRead: false,
  },
];
